<template>
  <div>
   <base-list-management
     ref="baseListManagement"
     :configData.sync="configData"
     @searchForm="searchForm"
   />
   <!-- 上保险 -->
   <add-insurance
       v-model="addInsuranceShow"
       :loading="oLoading"
       :plateNo="plateNo"
       @refresh="searchForm"
     />
     <!-- 处置 -->
     <Disposal
       v-model="disposalShow"
       :plateNo="plateNo"
       :vin="vin"
       :carId="carId"
       :carState="carState"
       @refresh="searchForm"
     />
  </div>
 </template>

<script>
// eslint-disable-next-line import/no-cycle
import manageLsit from '../config/waitForRentCarList'
import AddInsurance from '@/pages/service/components/AddInsurance'
import Disposal from '../components/Disposal.vue'
import { getTenantCustomTagList } from '@/api/domain/orders'
import { readyLease } from '@/api/carManage'
import { mapGetters } from 'vuex'

export default {
  components: {
    AddInsurance,
    Disposal,
  },
  data() {
    const { configData } = manageLsit.call(this)
    return {
      configData,
      searchData: {},
      oLoading: {
        search: false,
        fuzzySearch: false,
      },
      // 所有操作
      addInsuranceShow: false, // 上保险
      plateNo: '',
      disposalShow: false,
      carId: '',
      vin: '',
      carState: '',
    }
  },
  computed: {
    // eslint-disable-next-line vue/no-unused-properties
    ...mapGetters(['carStateList', 'allCities']),
  },
  watch: {
    allCities: {
      handler(val) {
        this.configData.formData.list.find(
          (item) => item.itemConfig.prop === 'adcode',
        ).elConfig.options.list = val
      },
      immediate: true,
    },
  },
  methods: {
    // 处理搜索参数 src/pages/orders/waitForRent/config/waitForRentCarList.js 有调用
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearch(params) {
      const theParams = params
      theParams.carState = 20
      theParams.exitOperationState = 0
      // 时间处理
      if (params.carCreateTime && params.carCreateTime.length) {
        theParams.carCreateStartDate = params.carCreateTime[0]
        theParams.carCreateEndDate = params.carCreateTime[1]
      }
      this.searchData = theParams
      // 处理品牌车系车型
      const { brandSeriesModel } = theParams
      const postParams = {
        ...theParams,
        brandId: brandSeriesModel.brandId,
        modelId: brandSeriesModel.modelId,
        seriesId: brandSeriesModel.seriesId,
      }
      delete postParams.brandSeriesModel
      return postParams
    },
    // 搜索事件
    searchForm() {
      const resourceKey = this.$route.name
      this.dataBase.save(resourceKey, {
        searchKey: 'searchData',
        value: this.searchData,
        carList: this.carList || [], // 将车辆车牌号信息存起来，反显时候用
        ts: new Date().getTime(),
      })
      this.$refs.baseListManagement.searchForm()
    },
    // 全部标签 src/pages/orders/waitForRent/config/waitForRentCarList.js 有调用
    // eslint-disable-next-line vue/no-unused-properties
    getTenantCustomTagList() {
      getTenantCustomTagList({
        type: 1,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'tagId', data })
        }
      })
    },
    // 详情---操作 src/pages/orders/waitForRent/config/waitForRentCarList.js 有调用
    // eslint-disable-next-line vue/no-unused-properties
    lookCarDetail(row) {
      const { moduleName } = this
      if (this.judgePermission('vehicle_list_detail')) {
        this.$router.push({
          query: { id: row.id, source: moduleName, plateNo: row.plateNo },
          path: '/car_to_lease/vehicleManage/detail',
        })
      }
    },
    // 编辑---操作src/pages/orders/waitForRent/config/waitForRentCarList.js 有调用
    // eslint-disable-next-line vue/no-unused-properties
    editCar(data) {
      if (data.basicItemState === 3) {
        const str =
           '审核中，车辆不可编辑信息，提示车辆信息审核中，请审核结束后再修改'
        this.$alert(str, '提示', {
          confirmButtonText: '确定',
          callback: () => null,
        })
      } else {
        this.$router.push({
          path: '/car_to_lease/vehicleManage/edit',
          query: {
            id: data.id,
          },
        })
      }
    },
    // 处置---操作 src/pages/orders/waitForRent/config/waitForRentCarList.js 有调用
    // eslint-disable-next-line vue/no-unused-properties
    dealCar(row) {
      this.disposalShow = true
      this.plateNo = row.plateNo
      this.carId = row.id
      this.vin = row.vin
      this.carState = row.carState
    },
    // 上保险---操作 src/pages/orders/waitForRent/config/waitForRentCarList.js 有调用
    // eslint-disable-next-line vue/no-unused-properties
    addInsure(row) {
      this.addInsuranceShow = true
      this.plateNo = row.plateNo
    },
    // 保养---操作 src/pages/orders/waitForRent/config/waitForRentCarList.js 有调用
    // eslint-disable-next-line vue/no-unused-properties
    careCar(row) {
      this.$router.push({
        query: { type: 2, plateNo: row.plateNo },
        path: '/car_to_lease/maintenance/add',
      })
    },
    // 维修---操作 src/pages/orders/waitForRent/config/waitForRentCarList.js 有调用
    // eslint-disable-next-line vue/no-unused-properties
    fixCar(row) {
      this.$router.push({
        query: { type: 1, plateNo: row.plateNo },
        path: '/car_to_lease/maintenance/add',
      })
    },
    // 事故---操作 src/pages/orders/waitForRent/config/waitForRentCarList.js 有调用
    // eslint-disable-next-line vue/no-unused-properties
    accidentCar(row) {
      this.$router.push({
        query: { plateNo: row.plateNo },
        path: '/car_to_lease/accident/add',
      })
    },
    // 0:去掉备车标签，1:设为备车标签 src/pages/orders/waitForRent/config/waitForRentCarList.js 有调用
    // eslint-disable-next-line vue/no-unused-properties
    async handlePrepareCar(row, prepareStatus) {
      const { code } = await readyLease({
        id: row.id,
        readyLeaseState: prepareStatus,
      })
      if (code === 1) {
        this.$message.success(`${prepareStatus ? '车辆已设置为' : '已操作取消'}备车`)
        this.$refs.baseListManagement.searchForm()
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    customizeReset() {
      this.$refs.baseListManagement.setItemData({
        elConfigKey: 'value',
        key: 'brandSeriesModel',
        data: {},
      })
    },
    // 跳转到签约提车
    // eslint-disable-next-line vue/no-unused-properties
    signCar(row) {
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/personalSignContract',
        query: {
          plateNo: row.plateNo,
        },
      })
    },
  },
}
</script>
